import React, { useState, useEffect } from 'react'
import ToggleButtons from '../../components/Shared/ToggleButtons/ToggleButtons'
import QuillInput from '../../components/Shared/QuillInput/QuillInput';
import { showErrorToast, showSuccessToast } from '../../components/Shared/Toastify/toastHelper';
import { CircularProgress } from '@mui/material';
import { PrivacyService } from '../../services/PrivacyService';
import { useWebSettings } from '../../context/WebSettingsContext';

function Privacy() {
  const label = [
    { label_name: "English", index: 0 },
    { label_name: "French", index: 1 },
    { label_name: "Arabic", index: 2 }
  ];
  const [activeButton, setActiveButton] = useState(0);
  const { webSettings, updateWebSettings, loading: contextLoading } = useWebSettings();
  const [localPrivacy, setLocalPrivacy] = useState({
    eng: "",
    fr: "",
    ar: ""
  });
  const [loading, setLoading] = useState<boolean>(false);
  
  useEffect(() => {
    if (webSettings.privacyPolicy) {
      setLocalPrivacy(webSettings.privacyPolicy);
    }
  }, [webSettings]);

  const handleSetActiveButton = (value: number) => {
    setActiveButton(value);
  };

  const validateForm = (): boolean => {
    const missingFields: string[] = [];
    
    // Check English fields
    if (!localPrivacy.eng?.trim()) missingFields.push('English Content');
    
    // Check French fields
    if (!localPrivacy.fr?.trim()) missingFields.push('French Content');
    
    // Check Arabic fields
    if (!localPrivacy.ar?.trim()) missingFields.push('Arabic Content');

    if (missingFields.length > 0) {
      showErrorToast(`The following fields are missing: ${missingFields.join(', ')}`);
      return false;
    }

    return true;
  };

  const handleContentChange = (value: string) => {
    const language = activeButton === 0 ? 'eng' : activeButton === 1 ? 'fr' : 'ar';
    setLocalPrivacy(prev => ({
      ...prev,
      [language]: value
    }));
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    setLoading(true);
    try {
      await PrivacyService.createPrivacy(localPrivacy, webSettings._id);
      await updateWebSettings({ privacyPolicy: localPrivacy });
      showSuccessToast("Privacy Policy saved successfully");
    } catch (error: any) {
      showErrorToast(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const getCurrentContent = () => {
    switch (activeButton) {
      case 0:
        return localPrivacy.eng;
      case 1:
        return localPrivacy.fr;
      case 2:
        return localPrivacy.ar;
      default:
        return '';
    }
  };

  if (contextLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className='flex flex-col gap-[40px]'>
      <ToggleButtons
        labels={label}
        activeButton={activeButton}
        setActiveButton={handleSetActiveButton}
      />
      
      <QuillInput 
        key={`quill-${activeButton}`}
        title='Details'
        value={getCurrentContent()}
        onChange={handleContentChange}
      />
      <button 
        onClick={handleSave}
        className='ml-auto bg-[#00726B] rounded-[8px] h-[48px] w-[140px] text-[14px] font-medium text-white'
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : "SAVE"}
      </button>
    </div>
  );
}

export default Privacy;